import React from 'react'
import Header from '../components/Header/Header'
import Footer from '../components/Header/Footer'
import Contact from '../components/Homecomps/contact'
import './contactpage.css'
import './Servicess.css'

const Contactpage = () => {
  return (
    <div className='main'>
<Header/>
<Contact />
<Footer/>


    </div>
  )
}

export default Contactpage